import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import { ProgressMultiItem, ProgressMulti, Separator } from 'twyne-new.ui';

import { LOADING } from 'stores/BaseStore';

import { Card, Loader } from './card';

const propTypes = {
  title: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  field: PropTypes.string,
  addField: PropTypes.func,
};

const BARS_COLORS = ['accent', 'success', 'warning', 'danger', 'neutral']

const formatNumber = value => <NumberFormat value={value} displayType="text" thousandSeparator="," />

function ProgressBar({ data, index, onAddFilter }) {
  return <ProgressMultiItem
    color={BARS_COLORS[index % (BARS_COLORS.length - 1)]}
    value={data.totalPC * 100}
    onClick={() => onAddFilter(data.key)}
    tiptap={data.name || data.name}
  />
}

export default function ProgressCard({ data, status, title, withTip: WithTip, ...props }) {
  return <Card>
    <Loader loading={status === LOADING || !data}>
      {title}
    </Loader>

    <ProgressMulti size='sm' fadeColor>
      {data?.map((bucket, idx) => <ProgressBar key={idx} index={idx} data={bucket} {...props} />)}
    </ProgressMulti>

    <div className={`grid grid-cols-${data?.length} mt-4 gap-x-0 gap-y-4`}>
      {data?.map((bucket, idx) => <div key={idx} className='flex flex-col align-items-center px-3 py-0 twy-border-base items-center gap-2'>
        <span className='text-xl twy-text-base-accent'>{(bucket.totalPC * 100).toFixed()}%</span>
        <div className='flex flex-col items-center'>
          <span className='text-md'>{formatNumber(bucket.total)}</span>
          <span className='twy-text-base-neutral'>{WithTip ? <WithTip field={bucket.name} /> : bucket.name}</span>
        </div>
      </div>)}
    </div>
  </Card>
}

ProgressCard.propTypes = propTypes;
